import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiGlobeAlt, HiChevronDown, HiChevronUp } from 'react-icons/hi';

const InlineLanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'cs', name: 'Čeština', flag: '🇨🇿' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    setIsExpanded(false);
  };

  return (
    <div className="w-full">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setIsExpanded(!isExpanded);
        }}
        className="w-full flex items-center justify-between px-0 py-1 text-sm text-gray-700 hover:text-gray-900 transition-colors duration-200"
      >
        <div className="flex items-center gap-2">
          <HiGlobeAlt size={16} />
          <span>{currentLanguage.flag} {currentLanguage.name}</span>
        </div>
        {isExpanded ? <HiChevronUp size={12} /> : <HiChevronDown size={12} />}
      </button>

      {isExpanded && (
        <div className="mt-2 pl-6 space-y-1">
          {languages.map((language) => (
            <button
              key={language.code}
              onClick={(e) => {
                e.stopPropagation();
                changeLanguage(language.code);
              }}
              className={`w-full text-left px-2 py-1 text-sm rounded transition-colors duration-200 flex items-center gap-2 ${
                i18n.language === language.code
                  ? 'bg-blue-50 text-blue-600'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-800'
              }`}
            >
              <span>{language.flag}</span>
              <span>{language.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default InlineLanguageSwitcher;
